import { render, staticRenderFns } from "./OrderMade.vue?vue&type=template&id=1579bcb6&scoped=true"
import script from "./OrderMade.vue?vue&type=script&lang=js"
export * from "./OrderMade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1579bcb6",
  null
  
)

export default component.exports